/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class UtilitiesService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get Data Format Version Number
     * Return the latest solver data format version.
     * @returns number Successful Response
     * @throws ApiError
     */
    public getDataFormatVersionNumberUtilitiesDataFormatVersionGet(): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/utilities:data_format_version',
            errors: {
                404: `Not found`,
            },
        });
    }
}
